import {
  Order,
  OrderErrorType,
  SetCurrentOrderAction,
  ResetCurrentOrderAction,
  SetCurrentOrderErrorAction,
  ResetCurrentOrderErrorAction,
} from './types';

export enum CurrentOrderActionType {
  setCurrentOrder = 'CURRENT_ORDER/SET_ORDER',
  resetCurrentOrder = 'CURRENT_ORDER/RESET_ORDER',
  setCurrentOrderError = 'CURRENT_ORDER/SET_ORDER_ERROR',
  resetCurrentOrderError = 'CURRENT_ORDER/RESET_ORDER_ERROR',
}

export const setCurrentOrder = (order: Order): SetCurrentOrderAction => ({
  type: CurrentOrderActionType.setCurrentOrder,
  payload: order,
});

export const resetCurrentOrder = (): ResetCurrentOrderAction => ({
  type: CurrentOrderActionType.resetCurrentOrder,
  payload: null,
});

export const setCurrentOrderError = (
  errorType: OrderErrorType
): SetCurrentOrderErrorAction => ({
  type: CurrentOrderActionType.setCurrentOrderError,
  payload: errorType,
});

export const resetCurrentOrderError = (): ResetCurrentOrderErrorAction => ({
  type: CurrentOrderActionType.resetCurrentOrderError,
});
